module.exports = __webpack_public_path__ + "static/img/dynamicu.52028c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicu.png
// module id = oNAH
// module chunks = 45